<div class="modal-header">
    <h2 mat-dialog-title>Related Cards</h2>
    <div class="header-buttons">
        <button (click)="onPin()" class="btn btn-icon btn-transparent" tabindex="-1">
            <span class="material-icons-outlined">push_pin</span>
        </button>
        <button (click)="onClose()" class="btn btn-icon btn-transparent" tabindex="-1">
            <span class="material-icons-outlined">close</span>
        </button>
    </div>
</div>

<mat-dialog-content class="modal-content">
    <div *ngIf="!dataLoaded" class="skeleton-main">
        <div class="skeleton skeleton-box-big"></div>
    </div>
    <app-related-cards
        *ngIf="dataLoaded"
        [confidenceModel]="confidenceModel"
        [seqMode]="seqMode"
        (seqModeChange)="onSeqModeChange($event)"
        (reloadCards)="onReloadCards()">
    </app-related-cards>
</mat-dialog-content>
